import { EventEmitter, Component, Input, Output, ViewEncapsulation, ChangeDetectorRef, ContentChild, Pipe, NgModule, CUSTOM_ELEMENTS_SCHEMA, ContentChildren, ViewChild, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@wke/ucc-icons';
import { CdaService } from '@wke/ucc-angular-utils';
import { PortalModule } from '@angular/cdk/portal';
import { trigger, transition, style, animate } from '@angular/animations';
import { FormsModule } from '@angular/forms';
import '@wk/components/dist/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Este componente se utiliza para la declaración de la modal lateral del ServiceCode.
 * Este componente nos da el layout del service code, con un titulo acompañado de un texto,
 * más una zona libre donode podemos incrustar, por ejemplo,
 * [ServiceCodeCard]{@link ServiceCodeCardComponent} y/o [HelpLinks]{@link HelpLinksComponent}
 *
 * @example
 * <ucc-service-code-layout
 * title="¿Cómo podemos ayudarte?"
 * textHeader="Estamos aquí para ayudarte en lo que haga falta, puedes preguntarnos lo que quieras, o dejarnos una sugerencia si lo deseas."
 * (close)="onClose()">
 * <div>
 *  <!-- CONTENT -->
 * </div>
 * </ucc-service-code-layout>
 *
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@wke/ucc-icons';
import * as ɵngcc3 from '@wke/ucc-angular-utils';
import * as ɵngcc4 from '@angular/cdk/drag-drop';
import * as ɵngcc5 from '@angular/platform-browser';
import * as ɵngcc6 from '@angular/common/http';

function ServiceCodeLayoutComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "ucc-icon", 10);
    ɵngcc0.ɵɵlistener("click", function ServiceCodeLayoutComponent_div_2_Template_ucc_icon_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onClose(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
const _c0 = ["*"];
const _c1 = ["linkItemTemplate"];
function HelpLinksComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "span", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.title);
} }
function HelpLinksComponent_div_0_ng_container_2_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 15);
    ɵngcc0.ɵɵelementStart(4, "div", 16, 17);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("key", item_r3.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", item_r3.description);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", item_r3.description, " ");
} }
const _c2 = function (a0) { return { $implicit: a0 }; };
function HelpLinksComponent_div_0_ng_container_2_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementContainer(1, 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.linkItemTemplateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c2, item_r3));
} }
function HelpLinksComponent_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function HelpLinksComponent_div_0_ng_container_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const item_r3 = ɵngcc0.ɵɵnextContext().$implicit; return item_r3.click(); });
    ɵngcc0.ɵɵtemplate(1, HelpLinksComponent_div_0_ng_container_2_div_1_ng_container_1_Template, 7, 3, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(2, HelpLinksComponent_div_0_ng_container_2_div_1_div_2_Template, 2, 4, "div", 9);
    ɵngcc0.ɵɵelement(3, "div", 10);
    ɵngcc0.ɵɵelementStart(4, "div", 11);
    ɵngcc0.ɵɵelement(5, "ucc-icon", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", item_r3.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.linkItemTemplateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.linkItemTemplateRef);
} }
function HelpLinksComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HelpLinksComponent_div_0_ng_container_2_div_1_Template, 6, 3, "div", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isFunctionInformed(item_r3.click));
} }
function HelpLinksComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, HelpLinksComponent_div_0_div_1_Template, 3, 1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, HelpLinksComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.title.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
const _c3 = function (a0) { return { "color": a0 }; };
const _c4 = function (a0) { return { "background-color": a0 }; };
function ServiceCodeButtonCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "button", 5);
    ɵngcc0.ɵɵlistener("click", function ServiceCodeButtonCardComponent_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onButtonClick(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("id", ctx_r0.getButtonId())("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c4, ctx_r0.color));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.buttonText);
} }
function ServiceCodeNumberCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "uccServiceCode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r0.tenant), " ");
} }
function CarouselItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@slide", ctx_r0.slideAnimationType);
} }
function CarouselComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onPreviousClick(); });
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = function (a0) { return { selectedPoint: a0 }; };
function CarouselComponent_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_div_3_span_1_Template_div_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const i_r7 = restoredCtx.index; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.goToSlide(i_r7); });
    ɵngcc0.ɵɵtext(2, ".");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c5, ctx_r5.isCurrentSlide(i_r7)));
} }
function CarouselComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, CarouselComponent_div_3_span_1_Template, 3, 3, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.carouselItemsList);
} }
function CarouselComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onNextClick(); });
    ɵngcc0.ɵɵelement(1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} }
const _c6 = ["accordionItem"];
function AccordionItemComponent_ng_content_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1, ["*ngIf", "isCreated"]);
} }
const _c7 = [[["header"]], [["content"]]];
const _c8 = ["header", "content"];
function DragDropComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "", ctx_r0.id, "_dragicon");
} }
const _c9 = ["contextualMenu"];
function CardLinkComponent_div_0_ucc_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ucc-icon", 9);
} }
function CardLinkComponent_div_0_ucc_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ucc-icon", 10);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("key", ctx_r3.icon)("iconColor", ctx_r3.iconColor);
} }
function CardLinkComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("background-image", ctx_r4.backgroundImage);
} }
function CardLinkComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function CardLinkComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onClickCardLink(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3, 4);
    ɵngcc0.ɵɵlistener("click", function CardLinkComponent_div_0_Template_div_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onClickContextualMenu($event); });
    ɵngcc0.ɵɵtemplate(4, CardLinkComponent_div_0_ucc_icon_4_Template, 1, 0, "ucc-icon", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵtemplate(6, CardLinkComponent_div_0_ucc_icon_6_Template, 1, 2, "ucc-icon", 6);
    ɵngcc0.ɵɵtemplate(7, CardLinkComponent_div_0_div_7_Template, 1, 2, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c4, ctx_r0.backgroundColor));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canShowContextualMenu());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon && !ctx_r0.cardLink.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.cardLink.image);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.cardLinkTitle, " ");
} }
function CardLinkContainerComponent_ucc_card_link_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ucc-card-link", 2);
} if (rf & 2) {
    const cardLink_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cardLink", cardLink_r1);
} }
class ServiceCodeLayoutComponent {
    constructor() {
        /**
         * Permite definir el titulo. Es opcional. Si se indica titulo,
         * se muestra conjuntamente con la 'X' de cerrar ventana y se puede suscribir al 'close'.
         * En caso de no indicar titulo, tampoco se muestra la 'X'. Se entiende que se hace uso de una modal y no requiere de esta funcionalidad.
         */
        this.title = null;
        /**
         * Permite definir el texto que aparece en la cabecera debajo del título.
         */
        this.textHeader = null;
        /**
          * Emite un evento cuando se hace click en la 'X' que aparece junto al titulo.
          */
        this.close = new EventEmitter();
    }
    /** @ignore */
    onClose() {
        this.close.emit();
    }
}
ServiceCodeLayoutComponent.ɵfac = function ServiceCodeLayoutComponent_Factory(t) { return new (t || ServiceCodeLayoutComponent)(); };
ServiceCodeLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ServiceCodeLayoutComponent, selectors: [["ucc-service-code-layout"]], hostAttrs: [1, "rowAvailable", "verticalLayout"], inputs: { title: "title", textHeader: "textHeader" }, outputs: { close: "close" }, ngContentSelectors: _c0, decls: 8, vars: 2, consts: [[1, "rowAvailable", "verticalLayout", "serviceCodeLayout"], [1, "rowAuto", "verticalLayout", "serviceCodeModalHeader"], ["class", "rowAuto horizontalLayout titleRow", 4, "ngIf"], [1, "rowAuto"], [1, "textContent"], [1, "rowAvailable", "serviceCodeModalContent"], [1, "rowAuto", "horizontalLayout", "titleRow"], [1, "colAvailable"], [1, "title"], [1, "colAuto"], ["tabindex", "0", "key", "closeIcon", 1, "btnClose", 3, "click"]], template: function ServiceCodeLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ServiceCodeLayoutComponent_div_2_Template, 6, 1, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textHeader);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.IconComponent], styles: [".serviceCodeLayout[_ngcontent-%COMP%]{width:495px;font-size:13px}.serviceCodeModalHeader[_ngcontent-%COMP%]{background-color:#0081c6;color:#fff;padding:14px 16px 20px}.serviceCodeModalHeader[_ngcontent-%COMP%]   .titleRow[_ngcontent-%COMP%]{margin-bottom:15px}.serviceCodeModalHeader[_ngcontent-%COMP%]   .btnClose[_ngcontent-%COMP%]{cursor:pointer;background-color:transparent;font-size:20px}.serviceCodeModalHeader[_ngcontent-%COMP%]   .btnClose[_ngcontent-%COMP%]:focus{opacity:.75}.serviceCodeModalHeader[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:18px;margin-bottom:10px}.serviceCodeModalHeader[_ngcontent-%COMP%]   .textContent[_ngcontent-%COMP%]{margin-top:5px}.serviceCodeModalContent[_ngcontent-%COMP%]{padding:20px 16px 0}"] });
ServiceCodeLayoutComponent.propDecorators = {
    title: [{ type: Input }],
    textHeader: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodeLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-service-code-layout',
                template: "<div class=\"rowAvailable verticalLayout serviceCodeLayout\">\n  <div class=\"rowAuto verticalLayout serviceCodeModalHeader\">\n    <div *ngIf=\"title\" class=\"rowAuto horizontalLayout titleRow\">\n      <div class=\"colAvailable\">\n        <span class=\"title\">{{ title }}</span>\n      </div>\n      <div class=\"colAuto\">\n        <ucc-icon\n          tabindex=\"0\"\n          class=\"btnClose\"\n          key=\"closeIcon\"\n          (click)=\"onClose()\"\n        ></ucc-icon>\n      </div>\n    </div>\n    <div class=\"rowAuto\">\n      <span class=\"textContent\">{{ textHeader }}</span>\n    </div>\n  </div>\n  <div class=\"rowAvailable serviceCodeModalContent\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                host: { class: 'rowAvailable verticalLayout' },
                styles: [".serviceCodeLayout{width:495px;font-size:13px}.serviceCodeModalHeader{background-color:#0081c6;color:#fff;padding:14px 16px 20px}.serviceCodeModalHeader .titleRow{margin-bottom:15px}.serviceCodeModalHeader .btnClose{cursor:pointer;background-color:transparent;font-size:20px}.serviceCodeModalHeader .btnClose:focus{opacity:.75}.serviceCodeModalHeader .title{font-size:18px;margin-bottom:10px}.serviceCodeModalHeader .textContent{margin-top:5px}.serviceCodeModalContent{padding:20px 16px 0}\n"]
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], textHeader: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();

/**
 * Este es el componente que crea los enlaces de ayuda que se mostrarán en la modal del servicecode
 *
 * @example
 *  <ucc-help-links title=""
 *                  items="itemlist">
 *  </ucc-help-links>
 *
 */
class HelpLinksComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        /**
         * Permite definir la cabecera de título de los links de ayuda
         */
        this.title = null;
        /**
         * Lista con la configuración de cada enlace de ayuda
         */
        this.items = [];
        this.linkItemTemplateRef = null;
    }
    ngOnInit() {
        this._cdr.detectChanges();
    }
    /** @ignore */
    isFunctionInformed(value) {
        return typeof value === 'function';
    }
}
HelpLinksComponent.ɵfac = function HelpLinksComponent_Factory(t) { return new (t || HelpLinksComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
HelpLinksComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HelpLinksComponent, selectors: [["ucc-help-links"]], contentQueries: function HelpLinksComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.linkItemTemplateRef = _t.first);
    } }, inputs: { title: "title", items: "items" }, decls: 1, vars: 1, consts: [["class", "helpLinkContainer", "title", "", 4, "ngIf"], ["title", "", 1, "helpLinkContainer"], ["class", "helpLinkTitle", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "helpLinkTitle"], [1, "helpLinkTitleText"], ["class", "helpLinkItem horizontalLayout", 3, "id", "click", 4, "ngIf"], [1, "helpLinkItem", "horizontalLayout", 3, "id", "click"], [4, "ngIf"], ["class", "helpLinkItemTemplate", 4, "ngIf"], [1, "colAvailable"], [1, "helpLinkAngleIcon", "colAuto", "alignMiddle"], ["key", "angle-right"], [1, "helpLinkIcon", "colAuto", "alignMiddle"], [3, "key"], [1, "helpLinkDescription", "colAuto", "alignMiddle"], [1, "helpLinkText", 3, "title"], ["descriptionText", ""], [1, "helpLinkItemTemplate"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function HelpLinksComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HelpLinksComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.IconComponent, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]     .helpLinkContainer{margin-top:30px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkTitle{font-size:16px;margin:16px 0}[_nghost-%COMP%]     .helpLinkContainer .helpLinkTitle .helpLinkTitleText{font-weight:bold}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem{border:2px solid #ddd;border-radius:5px;padding:10px 0;margin:10px 0;cursor:pointer;align-items:center}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem:hover{background-color:#f5f5f5}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkIcon{margin-left:10px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkIcon ucc-icon i{font-size:26px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkItemTemplate{margin-left:10px;font-weight:bold;font-size:16px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkDescription{display:table;table-layout:fixed;width:82%;margin-left:10px;font-size:16px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkDescription .helpLinkText{font-weight:bold;display:table-cell;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkAngleIcon{margin:0 10px}[_nghost-%COMP%]     .helpLinkContainer .helpLinkItem .helpLinkAngleIcon i{width:100%;height:100%;font-size:14px;color:#aaa}"] });
/** @nocollapse */
HelpLinksComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
HelpLinksComponent.propDecorators = {
    title: [{ type: Input }],
    items: [{ type: Input }],
    linkItemTemplateRef: [{ type: ContentChild, args: ['linkItemTemplate', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HelpLinksComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-help-links',
                template: "<div class=\"helpLinkContainer\" *ngIf=\"items && items.length > 0\" title=\"\">\n    <div class=\"helpLinkTitle\" *ngIf=\"title && title.length > 0\">\n        <span class=\"helpLinkTitleText\">{{title}}</span>\n    </div>\n\n    <ng-container *ngFor=\"let item of items\">\n        <div [id]=\"item.id\" class=\"helpLinkItem horizontalLayout\" *ngIf=\"isFunctionInformed(item.click)\"\n            (click)=\"item.click()\">\n\n            <ng-container *ngIf=\"!linkItemTemplateRef\">\n                <div class=\"helpLinkIcon colAuto alignMiddle\">\n                    <ucc-icon [key]=\"item.icon\"> </ucc-icon>\n                </div>\n\n                <div class=\"helpLinkDescription colAuto alignMiddle\">\n                    <div #descriptionText class=\"helpLinkText\" [title]=\"item.description\">{{ item.description }}\n                    </div>\n                </div>\n            </ng-container>\n\n            <div class=\"helpLinkItemTemplate\" *ngIf=\"linkItemTemplateRef\" >\n                <ng-container [ngTemplateOutlet]=\"linkItemTemplateRef\"\n                              [ngTemplateOutletContext]=\"{$implicit: item}\">\n                </ng-container>\n            </div>\n\n            <div class=\"colAvailable\"></div>\n\n            <div class=\"helpLinkAngleIcon colAuto alignMiddle\">\n                <ucc-icon key=\"angle-right\"> </ucc-icon>\n            </div>\n\n        </div>\n    </ng-container>\n</div>",
                encapsulation: ViewEncapsulation.Emulated,
                styles: [":host ::ng-deep .helpLinkContainer{margin-top:30px}:host ::ng-deep .helpLinkContainer .helpLinkTitle{font-size:16px;margin:16px 0}:host ::ng-deep .helpLinkContainer .helpLinkTitle .helpLinkTitleText{font-weight:bold}:host ::ng-deep .helpLinkContainer .helpLinkItem{border:2px solid #ddd;border-radius:5px;padding:10px 0;margin:10px 0;cursor:pointer;align-items:center}:host ::ng-deep .helpLinkContainer .helpLinkItem:hover{background-color:#f5f5f5}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkIcon{margin-left:10px}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkIcon ucc-icon i{font-size:26px}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkItemTemplate{margin-left:10px;font-weight:bold;font-size:16px}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkDescription{display:table;table-layout:fixed;width:82%;margin-left:10px;font-size:16px}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkDescription .helpLinkText{font-weight:bold;display:table-cell;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkAngleIcon{margin:0 10px}:host ::ng-deep .helpLinkContainer .helpLinkItem .helpLinkAngleIcon i{width:100%;height:100%;font-size:14px;color:#aaa}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { title: [{
            type: Input
        }], items: [{
            type: Input
        }], linkItemTemplateRef: [{
            type: ContentChild,
            args: ['linkItemTemplate', { static: false }]
        }] }); })();

/**
 * Este es el componente básico del Service Code Card, donde se le puede definir un contenido custom en el HTML.
 *
 * @example
 *  <service-code-card
 *      [id]="id"
 *      [icon]="icon"
 *      [title]="title"
 *      [text]="text">
 *          Content
 *  </service-code-card>
 *
 */
class ServiceCodeCardComponent {
    constructor() {
        /** Id del Service Code Card. */
        this.id = null;
        /** Icono del Service Code Card. */
        this.icon = null;
        /** Título del Service Code Card. */
        this.title = null;
        /** Texto o descripción del Service Code Card. */
        this.text = null;
        /** Color del Service Code Card. De manera predeterminada es el color azul corporativo. */
        this.color = '#0081C6';
    }
}
ServiceCodeCardComponent.ɵfac = function ServiceCodeCardComponent_Factory(t) { return new (t || ServiceCodeCardComponent)(); };
ServiceCodeCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ServiceCodeCardComponent, selectors: [["ucc-service-code-card"]], inputs: { id: "id", icon: "icon", title: "title", text: "text", color: "color" }, ngContentSelectors: _c0, decls: 11, vars: 8, consts: [[1, "horizontalLayout", "serviceCodeCardContainer", 3, "id"], [1, "colAuto", "serviceCodeCardIcon"], [3, "key", "iconBackgroundColor"], [1, "colAvailable"], [1, "verticalLayout"], [1, "serviceCodeCardTitle", "alignVerticalMiddle", 3, "ngStyle"], [1, "serviceCodeCardText"]], template: function ServiceCodeCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ucc-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div");
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("key", ctx.icon)("iconBackgroundColor", ctx.color);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c3, ctx.color));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.text, " ");
    } }, directives: [ɵngcc2.IconComponent, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]     .serviceCodeCardContainer{border:2px solid #ddd;border-radius:4px;padding:10px 15px;margin-bottom:20px}[_nghost-%COMP%]     .serviceCodeCardContainer .serviceCodeCardIcon{margin-right:15px}[_nghost-%COMP%]     .serviceCodeCardContainer .serviceCodeCardIcon ucc-icon i{height:30px;width:30px;border-radius:50%;background-color:#666;color:#fff;font-size:20px}[_nghost-%COMP%]     .serviceCodeCardContainer .serviceCodeCardTitle{height:30px;color:#666;font-size:16px;font-weight:bold;margin-bottom:5px}"] });
ServiceCodeCardComponent.propDecorators = {
    id: [{ type: Input }],
    icon: [{ type: Input }],
    title: [{ type: Input }],
    text: [{ type: Input }],
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodeCardComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-service-code-card',
                template: "<div id=\"{{id}}\" class=\"horizontalLayout serviceCodeCardContainer\">\n    <div class=\"colAuto serviceCodeCardIcon\">\n        <ucc-icon [key]=\"icon\" [iconBackgroundColor]=\"color\"></ucc-icon>\n    </div>\n    <div class=\"colAvailable\">\n        <div class=\"verticalLayout\">\n            <div class=\"serviceCodeCardTitle alignVerticalMiddle\" [ngStyle]=\"{'color': color}\">\n                {{title}}\n            </div>\n            <div class=\"serviceCodeCardText\">\n                {{text}}\n            </div>\n            <div>\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</div>",
                styles: [":host ::ng-deep .serviceCodeCardContainer{border:2px solid #ddd;border-radius:4px;padding:10px 15px;margin-bottom:20px}:host ::ng-deep .serviceCodeCardContainer .serviceCodeCardIcon{margin-right:15px}:host ::ng-deep .serviceCodeCardContainer .serviceCodeCardIcon ucc-icon i{height:30px;width:30px;border-radius:50%;background-color:#666;color:#fff;font-size:20px}:host ::ng-deep .serviceCodeCardContainer .serviceCodeCardTitle{height:30px;color:#666;font-size:16px;font-weight:bold;margin-bottom:5px}\n"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], icon: [{
            type: Input
        }], title: [{
            type: Input
        }], text: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

/**
 * Este es el componente básico del Service Code Card, donde se le puede definir un contenido custom en el HTML.
 *
 * @example
 *  <service-code-button-card
 *      [id]="id"
 *      [icon]="icon"
 *      [title]="title"
 *      [text]="text"
 *      [buttonText]="buttonText"
 *      (buttonClick)="buttonClick">
 *  </service-code-button-card>
 *
 */
class ServiceCodeButtonCardComponent {
    constructor() {
        /** Id del Service Code Button Card. */
        this.id = null;
        /** Icono del Service Code Button Card. */
        this.icon = null;
        /** Título del Service Code Button Card. */
        this.title = null;
        /** Texto o descripción del Service Code Button Card. */
        this.text = null;
        /** Color del Service Code Button Card. De manera predeterminada es el color azul corporativo. */
        this.color = '#0081C6';
        /** Texto del botón del Service Code Button Card. */
        this.buttonText = null;
        /** Permite saber cuando se ha hecho click al botón del Service Code Button Card. */
        this.buttonClick = new EventEmitter();
    }
    /**@ignore */
    onButtonClick() {
        this.buttonClick.emit();
    }
    /**@ignore */
    getButtonId() {
        return this.id + 'Btn';
    }
}
ServiceCodeButtonCardComponent.ɵfac = function ServiceCodeButtonCardComponent_Factory(t) { return new (t || ServiceCodeButtonCardComponent)(); };
ServiceCodeButtonCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ServiceCodeButtonCardComponent, selectors: [["ucc-service-code-button-card"]], inputs: { id: "id", icon: "icon", title: "title", text: "text", color: "color", buttonText: "buttonText" }, outputs: { buttonClick: "buttonClick" }, decls: 2, vars: 6, consts: [[3, "id", "icon", "title", "text", "color"], ["class", "horizontalLayout serviceCodeCardButtonContainer", 4, "ngIf"], [1, "horizontalLayout", "serviceCodeCardButtonContainer"], [1, "colAvailable"], [1, "colAuto"], [1, "buttonPrimary", "primaryButton", "serviceCodeCardButton", 3, "id", "ngStyle", "click"]], template: function ServiceCodeButtonCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ucc-service-code-card", 0);
        ɵngcc0.ɵɵtemplate(1, ServiceCodeButtonCardComponent_div_1_Template, 5, 5, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("icon", ctx.icon)("title", ctx.title)("text", ctx.text)("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonText && ctx.buttonClick);
    } }, directives: [ServiceCodeCardComponent, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]     .serviceCodeCardButtonContainer{padding:15px 10px 5px}[_nghost-%COMP%]     .serviceCodeCardButtonContainer .serviceCodeCardButton:focus{opacity:.8}[_nghost-%COMP%]     .serviceCodeCardButtonContainer .serviceCodeCardButton:hover{opacity:.6}"] });
ServiceCodeButtonCardComponent.propDecorators = {
    id: [{ type: Input }],
    icon: [{ type: Input }],
    title: [{ type: Input }],
    text: [{ type: Input }],
    color: [{ type: Input }],
    buttonText: [{ type: Input }],
    buttonClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodeButtonCardComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-service-code-button-card',
                template: "<ucc-service-code-card \n    [id]=\"id\"\n    [icon]=\"icon\"\n    [title]=\"title\"\n    [text]=\"text\"\n    [color]=\"color\">\n    <div *ngIf=\"buttonText && buttonClick\" class=\"horizontalLayout serviceCodeCardButtonContainer\">\n        <div class=\"colAvailable\"></div>\n        <div class=\"colAuto\">\n            <button [id]=\"getButtonId()\" class=\"buttonPrimary primaryButton serviceCodeCardButton\" [ngStyle]=\"{'background-color': color}\" (click)=\"onButtonClick()\">{{buttonText}}</button>\n        </div>\n    </div>\n</ucc-service-code-card>\n",
                styles: [":host ::ng-deep .serviceCodeCardButtonContainer{padding:15px 10px 5px}:host ::ng-deep .serviceCodeCardButtonContainer .serviceCodeCardButton:focus{opacity:.8}:host ::ng-deep .serviceCodeCardButtonContainer .serviceCodeCardButton:hover{opacity:.6}\n"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], icon: [{
            type: Input
        }], title: [{
            type: Input
        }], text: [{
            type: Input
        }], color: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], buttonClick: [{
            type: Output
        }] }); })();

/**
 * Este es el componente básico del Service Code Card, donde se le puede definir un contenido custom en el HTML.
 *
 * @example
 *  <service-code-number-card
 *      [id]="id"
 *      [icon]="icon"
 *      [title]="title"
 *      [text]="text"
 *      [tenant]="tenant">
 *  </service-code-number-card>
 *
 */
class ServiceCodeNumberCardComponent {
    constructor() {
        /**
         * id del Service Code Number Card
         */
        this.id = null;
        /**
         * icono del Service Code Number Card
         */
        this.icon = null;
        /**
         * título del Service Code Number Card
         */
        this.title = null;
        /**
         * texto del Service Code Number Card
         */
        this.text = null;
        /**
         * color del Service Code Number Card. De manera predeterminada es el color azul corporativo.
         */
        this.color = '#0081C6';
        /**
         * Código del tenant del Service Code Number Card
         */
        this.tenant = null;
    }
}
ServiceCodeNumberCardComponent.ɵfac = function ServiceCodeNumberCardComponent_Factory(t) { return new (t || ServiceCodeNumberCardComponent)(); };
ServiceCodeNumberCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ServiceCodeNumberCardComponent, selectors: [["ucc-service-code-number-card"]], inputs: { id: "id", icon: "icon", title: "title", text: "text", color: "color", tenant: "tenant" }, decls: 2, vars: 6, consts: [[3, "id", "icon", "title", "text", "color"], ["class", "alignMiddle serviceCodeNumberContainer", 4, "ngIf"], [1, "alignMiddle", "serviceCodeNumberContainer"], [1, "serviceCodeNumberDigits"]], template: function ServiceCodeNumberCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ucc-service-code-card", 0);
        ɵngcc0.ɵɵtemplate(1, ServiceCodeNumberCardComponent_div_1_Template, 4, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("icon", ctx.icon)("title", ctx.title)("text", ctx.text)("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tenant);
    } }, directives: function () { return [ServiceCodeCardComponent, ɵngcc1.NgIf]; }, pipes: function () { return [ServiceCodePipe]; }, styles: ["[_nghost-%COMP%]     .serviceCodeNumberContainer{padding:15px 10px 5px}[_nghost-%COMP%]     .serviceCodeNumberContainer .serviceCodeNumberDigits{background-color:#f5f5f5;padding:5px 15px;font-size:18px;font-weight:bold;letter-spacing:4px}"] });
ServiceCodeNumberCardComponent.propDecorators = {
    id: [{ type: Input }],
    icon: [{ type: Input }],
    title: [{ type: Input }],
    text: [{ type: Input }],
    color: [{ type: Input }],
    tenant: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodeNumberCardComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-service-code-number-card',
                template: "<ucc-service-code-card \n    [id]=\"id\"\n    [icon]=\"icon\"\n    [title]=\"title\"\n    [text]=\"text\"\n    [color]=\"color\">\n    <div *ngIf=\"tenant\" class=\"alignMiddle serviceCodeNumberContainer\">\n        <div class=\"serviceCodeNumberDigits\">\n            {{tenant | uccServiceCode}}\n        </div>\n    </div>\n</ucc-service-code-card>",
                styles: [":host ::ng-deep .serviceCodeNumberContainer{padding:15px 10px 5px}:host ::ng-deep .serviceCodeNumberContainer .serviceCodeNumberDigits{background-color:#f5f5f5;padding:5px 15px;font-size:18px;font-weight:bold;letter-spacing:4px}\n"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], icon: [{
            type: Input
        }], title: [{
            type: Input
        }], text: [{
            type: Input
        }], color: [{
            type: Input
        }], tenant: [{
            type: Input
        }] }); })();

/**
 * Esta Pipe sirve para obtener el service code a partir del tenant de cliente
 *
 * @example
 * HTML:
 * <p>{{ 'tenant_id' | uccServiceCode }}</p>
 *
 */
class ServiceCodePipe {
    constructor(_cdaService) {
        this._cdaService = _cdaService;
    }
    transform(value) {
        return this._cdaService.calculateCda(value);
    }
}
ServiceCodePipe.ɵfac = function ServiceCodePipe_Factory(t) { return new (t || ServiceCodePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.CdaService, 16)); };
ServiceCodePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "uccServiceCode", type: ServiceCodePipe, pure: true });
/** @nocollapse */
ServiceCodePipe.ctorParameters = () => [
    { type: CdaService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodePipe, [{
        type: Pipe,
        args: [{ name: 'uccServiceCode' }]
    }], function () { return [{ type: ɵngcc3.CdaService }]; }, null); })();

class CardsModule {
}
CardsModule.ɵfac = function CardsModule_Factory(t) { return new (t || CardsModule)(); };
CardsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardsModule });
CardsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    ServiceCodeCardComponent,
                    ServiceCodeButtonCardComponent,
                    ServiceCodeNumberCardComponent,
                    ServiceCodePipe
                ],
                exports: [
                    ServiceCodeCardComponent,
                    ServiceCodeButtonCardComponent,
                    ServiceCodeNumberCardComponent,
                    ServiceCodePipe
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardsModule, { declarations: function () { return [ServiceCodeCardComponent, ServiceCodeButtonCardComponent, ServiceCodeNumberCardComponent, ServiceCodePipe]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [ServiceCodeCardComponent, ServiceCodeButtonCardComponent, ServiceCodeNumberCardComponent, ServiceCodePipe]; } }); })();

class ServiceCodeModule {
}
ServiceCodeModule.ɵfac = function ServiceCodeModule_Factory(t) { return new (t || ServiceCodeModule)(); };
ServiceCodeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ServiceCodeModule });
ServiceCodeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule,
            CardsModule
        ], CardsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceCodeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule,
                    CardsModule
                ],
                declarations: [
                    ServiceCodeLayoutComponent,
                    HelpLinksComponent
                ],
                exports: [
                    ServiceCodeLayoutComponent,
                    HelpLinksComponent,
                    CardsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ServiceCodeModule, { declarations: function () { return [ServiceCodeLayoutComponent, HelpLinksComponent]; }, imports: function () { return [CommonModule,
        IconModule, CardsModule]; }, exports: function () { return [ServiceCodeLayoutComponent, HelpLinksComponent, CardsModule]; } }); })();

var CarouselSlideAnimationType;
(function (CarouselSlideAnimationType) {
    CarouselSlideAnimationType["Right"] = "right";
    CarouselSlideAnimationType["Left"] = "left";
    CarouselSlideAnimationType["None"] = "none";
})(CarouselSlideAnimationType || (CarouselSlideAnimationType = {}));

/**
 * Este componente utiliza para la declaración de carousel items
 * dentro de un componente de tipo [CarouselComponent]{@link CarouselComponent}
 * Dichos items, que funcionan como vistas, funcionan con ng-content, y pueden tener el contenido que el usuario desee
 *
 * @example
 * <ucc-carousel-item>Content</ucc-carousel-item>
 */
class CarouselItemComponent {
    /** @ignore */
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.disabled = true;
        this.slideAnimationType = CarouselSlideAnimationType.None;
    }
    //#region Public Methods
    /** @ignore */
    setSlideAnimationType(animation) {
        this.slideAnimationType = animation;
        this._changeDetectorRef.detectChanges();
    }
}
CarouselItemComponent.ɵfac = function CarouselItemComponent_Factory(t) { return new (t || CarouselItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CarouselItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselItemComponent, selectors: [["ucc-carousel-item"]], ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["class", "slide", 4, "ngIf"], [1, "slide"]], template: function CarouselItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CarouselItemComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]     .slide{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:transform .15s cubic-bezier(.25,.46,.45,.84)}[_nghost-%COMP%]     .slide>*:first-child{width:100%;height:100%}"], data: { animation: [
            trigger('slide', [
                transition('void => left', [
                    style({ transform: 'translateX(-100%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(0%)' }))
                ]),
                transition('left => void', [
                    style({ transform: 'translateX(0%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(100%)' }))
                ]),
                transition('void => right', [
                    style({ transform: 'translateX(100%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(0%)' }))
                ]),
                transition('right => void', [
                    style({ transform: 'translateX(0%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(-100%)' }))
                ])
            ])
        ] } });
/** @nocollapse */
CarouselItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselItemComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-carousel-item',
                template: "<div *ngIf=\"!disabled\" class=\"slide\" [@slide]=\"slideAnimationType\">\n    <ng-content></ng-content>\n</div>\n  ",
                animations: [
                    trigger('slide', [
                        transition('void => left', [
                            style({ transform: 'translateX(-100%)' }),
                            animate('500ms ease-in-out', style({ transform: 'translateX(0%)' }))
                        ]),
                        transition('left => void', [
                            style({ transform: 'translateX(0%)' }),
                            animate('500ms ease-in-out', style({ transform: 'translateX(100%)' }))
                        ]),
                        transition('void => right', [
                            style({ transform: 'translateX(100%)' }),
                            animate('500ms ease-in-out', style({ transform: 'translateX(0%)' }))
                        ]),
                        transition('right => void', [
                            style({ transform: 'translateX(0%)' }),
                            animate('500ms ease-in-out', style({ transform: 'translateX(-100%)' }))
                        ])
                    ])
                ],
                styles: [":host ::ng-deep .slide{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:transform .15s cubic-bezier(.25,.46,.45,.84)}:host ::ng-deep .slide>*:first-child{width:100%;height:100%}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * Este componente se utiliza para la declaración de un carousel, que esencialmente muestra una serie de vistas declaradas a través de
 * [CarouselItemComponent]{@link CarouselItemComponent} que pueden tener el contenido que el usuario desee.
 * Se puede navegar entre las diferentes vistas con las flechas de navegación y/o puntos de navegación.
 * También se puede navegar de forma custom, a través de los métodos de onNextClick(), onPreviousClick() y goToSlide(index).
 *
 * @example
 * <ucc-carousel [disableArrows]="disableArrows" [disablePoints]="disablePoints">
 *  <ucc-carousel-item>Content 1</ucc-carousel-item>
 *  <ucc-carousel-item>Content 2</ucc-carousel-item>
 *  <ucc-carousel-item>Content 3</ucc-carousel-item>
 * </ucc-carousel>
 *
 */
class CarouselComponent {
    constructor() {
        /** Permite activar o desactivar las arrows de navegación del carousel */
        this.disableArrows = false;
        /** Permite activar o desactivar los puntos de navegación del carousel */
        this.disablePoints = false;
        /** Slide actual del componente. Únicamente informativa, cambiarla de numero de realizará la navegación de slide correctamente. */
        this.currentSlide = 0;
        /** @ignore */
        this.carouselItemsList = null;
    }
    /** @ignore */
    ngAfterContentInit() {
        this.carouselItemsList = this._carouselItems.toArray();
        this.carouselItemsList[this.currentSlide].disabled = false;
    }
    /** Método que permite navegar a la anterior vista. Si es la primera vista, navegará a la última */
    onPreviousClick() {
        const previousSlide = (this.currentSlide - 1) < 0 ? this.carouselItemsList.length - 1 : (this.currentSlide - 1);
        this.manageAnimation(CarouselSlideAnimationType.Left, previousSlide);
    }
    /** Método que permite navegar a la siguiente vista. Si es la última vista, navegará a la primera */
    onNextClick() {
        const nextSlide = (this.currentSlide + 1) === this.carouselItemsList.length ? 0 : (this.currentSlide + 1);
        this.manageAnimation(CarouselSlideAnimationType.Right, nextSlide);
    }
    /** Método que permite navegar directamente a la vista indicada a través del index, siendo 0 la primera */
    goToSlide(index) {
        if (index !== this.currentSlide) {
            const animation = index < this.currentSlide ? CarouselSlideAnimationType.Left : CarouselSlideAnimationType.Right;
            this.manageAnimation(animation, index);
        }
    }
    manageAnimation(animation, slideToMove) {
        this.carouselItemsList[this.currentSlide].setSlideAnimationType(animation);
        this.carouselItemsList[this.currentSlide].disabled = true;
        this.currentSlide = slideToMove;
        this.carouselItemsList[this.currentSlide].setSlideAnimationType(animation);
        this.carouselItemsList[this.currentSlide].disabled = false;
    }
    /** @ignore */
    isCurrentSlide(index) {
        return this.currentSlide === index;
    }
}
CarouselComponent.ɵfac = function CarouselComponent_Factory(t) { return new (t || CarouselComponent)(); };
CarouselComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselComponent, selectors: [["ucc-carousel"]], contentQueries: function CarouselComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CarouselItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._carouselItems = _t);
    } }, inputs: { disableArrows: "disableArrows", disablePoints: "disablePoints" }, ngContentSelectors: _c0, decls: 5, vars: 3, consts: [[1, "carousel"], ["class", "control prev", 3, "click", 4, "ngIf"], ["class", "pointsContainer", 4, "ngIf"], ["class", "control next", 3, "click", 4, "ngIf"], [1, "control", "prev", 3, "click"], [1, "arrow", "left"], [1, "pointsContainer"], [4, "ngFor", "ngForOf"], [1, "point", 3, "ngClass", "click"], [1, "control", "next", 3, "click"], [1, "arrow", "right"]], template: function CarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, CarouselComponent_button_2_Template, 2, 0, "button", 1);
        ɵngcc0.ɵɵtemplate(3, CarouselComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, CarouselComponent_button_4_Template, 2, 0, "button", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableArrows);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disablePoints);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableArrows);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{flex:1}.carousel[_ngcontent-%COMP%]{position:relative;height:100%;width:100%;overflow:hidden}.control[_ngcontent-%COMP%]{position:absolute;border:none;background-color:transparent;outline:0;cursor:pointer;display:flex;flex-direction:column;justify-content:center;padding:.5em;color:#fff;font-weight:bold;font-size:2em;user-select:none;height:100%;opacity:80%;transition:opacity .15s cubic-bezier(.25,.46,.45,.84)}.control[_ngcontent-%COMP%]:hover, .control[_ngcontent-%COMP%]:focus{opacity:1}.control.next[_ngcontent-%COMP%]{right:0}.control.prev[_ngcontent-%COMP%]{left:0}.arrow[_ngcontent-%COMP%]{display:block;border-left:.1em solid white;border-bottom:.1em solid white;width:.5em;height:.5em}.arrow.left[_ngcontent-%COMP%]{transform:rotate(45deg)}.arrow.right[_ngcontent-%COMP%]{transform:rotate(225deg)}.pointsContainer[_ngcontent-%COMP%]{position:absolute;left:50%;bottom:0px;transform:translate(-50%,-50%);margin:0 auto;height:30px;display:flex;align-items:flex-end;justify-content:center;border:none;background-color:transparent}.pointsContainer[_ngcontent-%COMP%]   .point[_ngcontent-%COMP%]{margin:0 4px;cursor:pointer;color:#fff;font-weight:bold;font-size:2em;opacity:50%}.pointsContainer[_ngcontent-%COMP%]   .point.selectedPoint[_ngcontent-%COMP%]{opacity:100%}"] });
CarouselComponent.propDecorators = {
    disableArrows: [{ type: Input }],
    disablePoints: [{ type: Input }],
    _carouselItems: [{ type: ContentChildren, args: [CarouselItemComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-carousel',
                template: "<div class=\"carousel\">\n\n  <ng-content></ng-content>\n\n  <button *ngIf=\"!disableArrows\" class=\"control prev\" (click)=\"onPreviousClick()\">\n    <span class=\"arrow left\"></span>\n  </button>\n  <div *ngIf=\"!disablePoints\" class=\"pointsContainer\">\n    <span *ngFor=\"let slide of carouselItemsList; let i = index\">\n      <div (click)=\"goToSlide(i)\" class=\"point\" [ngClass]=\"{ selectedPoint : isCurrentSlide(i) }\">.</div>\n    </span>\n  </div>\n  <button *ngIf=\"!disableArrows\" class=\"control next\" (click)=\"onNextClick()\">\n    <span class=\"arrow right\"></span>\n  </button>\n\n</div>",
                styles: [":host{flex:1}.carousel{position:relative;height:100%;width:100%;overflow:hidden}.control{position:absolute;border:none;background-color:transparent;outline:0;cursor:pointer;display:flex;flex-direction:column;justify-content:center;padding:.5em;color:#fff;font-weight:bold;font-size:2em;user-select:none;height:100%;opacity:80%;transition:opacity .15s cubic-bezier(.25,.46,.45,.84)}.control:hover,.control:focus{opacity:1}.control.next{right:0}.control.prev{left:0}.arrow{display:block;border-left:.1em solid white;border-bottom:.1em solid white;width:.5em;height:.5em}.arrow.left{transform:rotate(45deg)}.arrow.right{transform:rotate(225deg)}.pointsContainer{position:absolute;left:50%;bottom:0px;transform:translate(-50%,-50%);margin:0 auto;height:30px;display:flex;align-items:flex-end;justify-content:center;border:none;background-color:transparent}.pointsContainer .point{margin:0 4px;cursor:pointer;color:#fff;font-weight:bold;font-size:2em;opacity:50%}.pointsContainer .point.selectedPoint{opacity:100%}\n"]
            }]
    }], function () { return []; }, { disableArrows: [{
            type: Input
        }], disablePoints: [{
            type: Input
        }], _carouselItems: [{
            type: ContentChildren,
            args: [CarouselItemComponent]
        }] }); })();

class CarouselModule {
}
CarouselModule.ɵfac = function CarouselModule_Factory(t) { return new (t || CarouselModule)(); };
CarouselModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CarouselModule });
CarouselModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PortalModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PortalModule,
                    IconModule
                ],
                declarations: [
                    CarouselComponent,
                    CarouselItemComponent
                ],
                exports: [
                    CarouselComponent,
                    CarouselItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CarouselModule, { declarations: function () { return [CarouselComponent, CarouselItemComponent]; }, imports: function () { return [CommonModule,
        PortalModule,
        IconModule]; }, exports: function () { return [CarouselComponent, CarouselItemComponent]; } }); })();

/**
 * Este componente sirve como contenedor de [AccordionItemComponents]{@link AccordionItemComponent}, donde se pueden declarar tantos
 * items como se desee.
 *
 * @example
 *   <ucc-accordion>
 *       <ucc-accordion-item>
 *           <header>
 *               ...
 *           </header>
 *           <content>
 *               ...
 *           </content>
 *       </ucc-accordion-item>
 *       <ucc-accordion-item>
 *           <header>
 *               ...
 *           </header>
 *           <content>
 *               ...
 *           </content>
 *       </ucc-accordion-item>
 *   </ucc-accordion>
 */
class AccordionComponent {
}
AccordionComponent.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(); };
AccordionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["ucc-accordion"]], ngContentSelectors: _c0, decls: 2, vars: 0, template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "wk-accordion");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item{border-bottom:none}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header{padding:10px 10px 10px 16px;border-bottom:.0625rem solid #dadada;background-color:#f9f9f9}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header:hover{background-color:#f2f8fc}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=true]{background-color:#f2f8fc}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header .wk-accordion-icon{display:flex;flex-direction:row;width:3.25rem;align-self:center;justify-content:center;height:auto!important;padding:0!important;margin:0!important}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header .fullSpace{height:100%;width:100%}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=true]+.wk-accordion-item-element{margin:0}[_nghost-%COMP%]     wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=false]+.wk-accordion-item-element{margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-accordion',
                template: "<wk-accordion>\n  <ng-content></ng-content>\n</wk-accordion>",
                encapsulation: ViewEncapsulation.Emulated,
                styles: [":host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item{border-bottom:none}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header{padding:10px 10px 10px 16px;border-bottom:.0625rem solid #dadada;background-color:#f9f9f9}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header:hover{background-color:#f2f8fc}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=true]{background-color:#f2f8fc}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header .wk-accordion-icon{display:flex;flex-direction:row;width:3.25rem;align-self:center;justify-content:center;height:auto!important;padding:0!important;margin:0!important}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header .fullSpace{height:100%;width:100%}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=true]+.wk-accordion-item-element{margin:0}:host ::ng-deep wk-accordion .wk-accordion wk-accordion-item .wk-accordion-item .wk-accordion-item-header[aria-expanded=false]+.wk-accordion-item-element{margin:0}\n"]
            }]
    }], null, null); })();

/**
 * Este componente se utiliza dentro del [AccordionComponents]{@link AccordionComponent}. Estos items sirven para mostrar u ocultar el
 * contenido que se define dentro. Por defecto el contenedor está cerrado.
 *
 * @example
 *       <ucc-accordion-item>
 *           <header>
 *               ...
 *           </header>
 *           <content>
 *               ...
 *           </content>
 *       </ucc-accordion-item>
 */
class AccordionItemComponent {
    constructor() {
        /** @ignore */
        this.isCreated = false;
        /** Sirve para definir el id del Accordion Item */
        this.id = null;
        /** Sirve para definir el estado disabled del Accordion Item. Por defecto está a false */
        this.disabled = false;
        this._isOpen = false;
        this._accordionItemElementRef = null;
    }
    /** @ignore */
    ngAfterViewInit() {
        setTimeout(() => this.deleteIconTitle());
    }
    /** @ignore */
    documentClick(event) {
        if (this.contains(event.target)) {
            setTimeout(() => this.deleteIconTitle());
        }
    }
    /** @ignore */
    enableIsCreated() {
        if (!this.isCreated) {
            this.isCreated = true;
        }
    }
    /** @ignore */
    get isOpen() {
        return this._isOpen;
    }
    contains(target) {
        const accordionItemHeader = this._accordionItemElementRef.nativeElement.getElementsByClassName('wk-accordion-item-header')[0];
        return accordionItemHeader ? accordionItemHeader.contains(target) : false;
    }
    deleteIconTitle() {
        if (this._accordionItemElementRef) {
            // Elemento HTML 'wk-icon' que contiene una propiedad 'title'
            const accordionItemIcon = this._accordionItemElementRef.nativeElement.getElementsByClassName('wk-accordion-icon')[0];
            // Elemento HTML de tipo 'title'
            const accordionItemIconTitle = this._accordionItemElementRef.nativeElement.getElementsByTagName('title')[0];
            // Borramos la propiedad title al elemento HTML 'wk-icon'
            if (accordionItemIcon) {
                accordionItemIcon.removeAttribute('title');
            }
            // Borramos el elemento HTML de tipo 'title'
            if (accordionItemIconTitle) {
                accordionItemIconTitle.remove();
            }
        }
    }
    /** Sirve para definir el estado inicial del Accordion Item. Por defecto está cerrado */
    set isOpen(value) {
        this._isOpen = value;
        if (this._isOpen) {
            this.enableIsCreated();
        }
    }
}
AccordionItemComponent.ɵfac = function AccordionItemComponent_Factory(t) { return new (t || AccordionItemComponent)(); };
AccordionItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionItemComponent, selectors: [["ucc-accordion-item"]], viewQuery: function AccordionItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._accordionItemElementRef = _t.first);
    } }, hostBindings: function AccordionItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AccordionItemComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); });
    } }, inputs: { id: "id", disabled: "disabled", isOpen: "isOpen" }, ngContentSelectors: _c8, decls: 6, vars: 4, consts: [[3, "id", "expanded", "disabled", "click"], ["accordionItem", ""], ["slot", "item-header", 1, "fullSpace"], ["slot", "item", 1, "fullSpace"], [4, "ngIf"]], template: function AccordionItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "wk-accordion-item", 0, 1);
        ɵngcc0.ɵɵlistener("click", function AccordionItemComponent_Template_wk_accordion_item_click_0_listener() { return ctx.enableIsCreated(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, AccordionItemComponent_ng_content_5_Template, 1, 0, "ng-content", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("expanded", ctx.isOpen)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isCreated);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
AccordionItemComponent.propDecorators = {
    id: [{ type: Input }],
    disabled: [{ type: Input }],
    _accordionItemElementRef: [{ type: ViewChild, args: ['accordionItem', { read: ElementRef, static: true },] }],
    documentClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    isOpen: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionItemComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-accordion-item',
                template: "<wk-accordion-item #accordionItem [id]=\"id\" [expanded]=\"isOpen\" [disabled]=\"disabled\" (click)=\"enableIsCreated()\">\n  <div slot=\"item-header\" class=\"fullSpace\">\n    <ng-content select=\"header\"></ng-content>\n  </div>\n  <div slot=\"item\" class=\"fullSpace\">\n    <ng-content *ngIf=\"isCreated\" select=\"content\"></ng-content>\n  </div>\n</wk-accordion-item>",
                encapsulation: ViewEncapsulation.Emulated
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], _accordionItemElementRef: [{
            type: ViewChild,
            args: ['accordionItem', { read: ElementRef, static: true }]
        }], 
    /** @ignore */
    documentClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], isOpen: [{
            type: Input
        }] }); })();

class AccordionModule {
}
AccordionModule.ɵfac = function AccordionModule_Factory(t) { return new (t || AccordionModule)(); };
AccordionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AccordionModule });
AccordionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    AccordionComponent,
                    AccordionItemComponent
                ],
                exports: [
                    AccordionComponent,
                    AccordionItemComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccordionModule, { declarations: function () { return [AccordionComponent, AccordionItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [AccordionComponent, AccordionItemComponent]; } }); })();

class DragDropComponent {
    constructor() {
        /** Sirve para definir el id del Drag&Drop */
        this.id = '';
        /** Sirve para mostrar/ocultar el handler/icono de arrastre */
        this.showHandle = true;
        /** Sirve para definir el tipo de posicionamiento: fixed o relative */
        this.position = 'fixed';
    }
}
DragDropComponent.ɵfac = function DragDropComponent_Factory(t) { return new (t || DragDropComponent)(); };
DragDropComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DragDropComponent, selectors: [["ucc-drag-drop"]], inputs: { id: "id", showHandle: "showHandle", position: "position" }, ngContentSelectors: _c0, decls: 3, vars: 3, consts: [["cdkDrag", "", 1, "ucc-drag-drop"], ["class", "ucc-drag-drop-handle", "cdkDragHandle", "", 4, "ngIf"], ["cdkDragHandle", "", 1, "ucc-drag-drop-handle"], ["key", "dragIcon", "iconClass", "dragging-icon", "iconSize", "12", "iconColor", "#999", 2, "margin-right", "3px", 3, "id"]], template: function DragDropComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, DragDropComponent_div_2_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("position", ctx.position);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showHandle);
    } }, directives: [ɵngcc4.CdkDrag, ɵngcc1.NgIf, ɵngcc4.CdkDragHandle, ɵngcc2.IconComponent], styles: [".ucc-drag-drop{background-color:inherit;padding:10px;z-index:99999999;transition:box-shadow .2s cubic-bezier(0,0,.2,1)}  .ucc-drag-drop:active{background-color:inherit;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}  .ucc-drag-drop-handle{position:absolute;top:5px;right:3px;cursor:grab;width:14px;height:14px}  .ucc-drag-drop-handle:active{cursor:grabbing}"] });
DragDropComponent.propDecorators = {
    id: [{ type: Input }],
    showHandle: [{ type: Input }],
    position: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragDropComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-drag-drop',
                template: "<div cdkDrag class=\"ucc-drag-drop\" [style.position]=\"position\">\n  <ng-content></ng-content>\n  <div *ngIf=\"showHandle\" class=\"ucc-drag-drop-handle\" cdkDragHandle>\n    <ucc-icon id=\"{{id}}_dragicon\" key=\"dragIcon\" iconClass=\"dragging-icon\" iconSize=\"12\" style=\"margin-right: 3px;\" iconColor=\"#999\"></ucc-icon>\n  </div>\n</div>\n",
                styles: ["::ng-deep .ucc-drag-drop{background-color:inherit;padding:10px;z-index:99999999;transition:box-shadow .2s cubic-bezier(0,0,.2,1)}::ng-deep .ucc-drag-drop:active{background-color:inherit;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}::ng-deep .ucc-drag-drop-handle{position:absolute;top:5px;right:3px;cursor:grab;width:14px;height:14px}::ng-deep .ucc-drag-drop-handle:active{cursor:grabbing}\n"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], showHandle: [{
            type: Input
        }], position: [{
            type: Input
        }] }); })();

class DragAndDropModule {
}
DragAndDropModule.ɵfac = function DragAndDropModule_Factory(t) { return new (t || DragAndDropModule)(); };
DragAndDropModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DragAndDropModule });
DragAndDropModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            DragDropModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragAndDropModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DragDropComponent
                ],
                exports: [
                    DragDropComponent
                ],
                imports: [
                    CommonModule,
                    DragDropModule,
                    IconModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DragAndDropModule, { declarations: function () { return [DragDropComponent]; }, imports: function () { return [CommonModule,
        DragDropModule,
        IconModule]; }, exports: function () { return [DragDropComponent]; } }); })();

/** Este componente se utiliza para la declaración de una tarjeta la cual contiene un enlace, un título y una imagen o icono.
 * Además tiene otras opciones como por ejemplo poder declarar que es de tipo Custom, lo cual permite que se le puedan añadir
 * opciones extras a través de un menú contextual. Las propiedades que contiene son del tipo [Card Link]{@link ICardLink}.
 *
 * @example
 *      <ucc-card-link
 *        [cardLink]="cardLink">
 *      </ucc-card-link>
 */
class CardLinkComponent {
    /** @ignore */
    constructor(_sanatizer, _httpClient, _cdr) {
        this._sanatizer = _sanatizer;
        this._httpClient = _httpClient;
        this._cdr = _cdr;
        /** Permite definir un objeto de tipo [Card Link]{@link ICardLink} */
        this.cardLink = null;
        /** @ignore */
        this.defaultBackgroundColor = '#FFFFFF';
        /** @ignore */
        this.customBackgroundColor = '#FBF5FF';
        /** @ignore */
        this.backgroundImage = null;
        this._defaultCardLink = {
            id: null,
            title: 'Default Title',
            url: null,
            image: null,
            icon: 'wkeLogoIcon',
            iconColor: '#666666',
            customContextualMenuClick: null
        };
    }
    /** @ignore */
    ngAfterViewInit() {
        var _a;
        if ((_a = this.cardLink) === null || _a === void 0 ? void 0 : _a.image) {
            this.convertToBackgroundImage(this.cardLink.image);
        }
    }
    convertToBackgroundImage(image) {
        if (image instanceof Blob) {
            this.setBlobAsBackgroundImage(image);
        }
        else if (typeof image === 'string') {
            this._httpClient.get(image, { responseType: 'blob' })
                .subscribe((imgBlob) => this.setBlobAsBackgroundImage(imgBlob));
        }
    }
    /** @ignore */
    canShowContextualMenu() {
        return this.cardLink.customized && this.cardLink.editable;
    }
    /** @ignore */
    onClickCardLink() {
        window.open(this.cardLink.url);
    }
    /** @ignore */
    onClickContextualMenu(event) {
        event.stopPropagation();
        if (this.cardLink.customContextualMenuClick) {
            this.cardLink.customContextualMenuClick(this._contextualMenu);
        }
    }
    setBlobAsBackgroundImage(image) {
        this.backgroundImage = this._sanatizer.bypassSecurityTrustStyle(`url('${URL.createObjectURL(image)}')`);
        this._cdr.detectChanges();
    }
    /** @ignore */
    get id() {
        const id = this.cardLink.id;
        if (!id) {
            throw new Error('No id was defined on ICardLink');
        }
        return id;
    }
    /** @ignore */
    get backgroundColor() {
        return this.cardLink.customized ? this.customBackgroundColor : this.defaultBackgroundColor;
    }
    /** @ignore */
    get cardLinkTitle() {
        var _a;
        return (_a = this.cardLink.title) !== null && _a !== void 0 ? _a : this._defaultCardLink.title;
    }
    get icon() {
        var _a;
        return (_a = this.cardLink.icon) !== null && _a !== void 0 ? _a : this._defaultCardLink.icon;
    }
    get iconColor() {
        var _a;
        return (_a = this.cardLink.iconColor) !== null && _a !== void 0 ? _a : this._defaultCardLink.iconColor;
    }
}
CardLinkComponent.ɵfac = function CardLinkComponent_Factory(t) { return new (t || CardLinkComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.HttpClient), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CardLinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardLinkComponent, selectors: [["ucc-card-link"]], viewQuery: function CardLinkComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contextualMenu = _t.first);
    } }, inputs: { cardLink: "cardLink" }, decls: 1, vars: 1, consts: [["class", "card-link", 3, "ngStyle", "click", 4, "ngIf"], [1, "card-link", 3, "ngStyle", "click"], [1, "card-link-custom"], [1, "card-link-custom__icon", 3, "click"], ["contextualMenu", ""], ["key", "moreVerticalIcon", 4, "ngIf"], ["class", "card-link__icon", 3, "key", "iconColor", 4, "ngIf"], ["class", "card-link__image", 3, "background-image", 4, "ngIf"], [1, "card-link__title"], ["key", "moreVerticalIcon"], [1, "card-link__icon", 3, "key", "iconColor"], [1, "card-link__image"]], template: function CardLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CardLinkComponent_div_0_Template, 10, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.id);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc2.IconComponent], styles: [".card-link{width:250px;height:125px;font-size:14px;border:1px solid #dadada;background-color:#fff;display:grid;grid-template-rows:0fr 3fr 3fr}  .card-link:hover{cursor:pointer;background-color:#eff9ff!important}  .card-link-custom{display:grid;justify-items:end}  .card-link-custom__icon{position:absolute;margin:5px;padding:4px;color:#666;border:0px;border-radius:50%;cursor:pointer}  .card-link-custom__icon .baseIcon{font-size:15px;width:auto;height:auto}  .card-link-custom__icon:hover{background-color:#eee}  .card-link-custom__icon:active{background-color:#666;color:#fff}  .card-link__icon .baseIcon{font-size:30px;display:grid;justify-content:center;align-content:end;height:100%;width:100%}  .card-link__image{height:100%;background-position:bottom;background-size:30px;background-color:transparent;background-repeat:no-repeat}  .card-link__title{color:#666;display:flex;justify-content:center;align-items:start;text-align:center;margin:5px;line-height:1.15}"] });
/** @nocollapse */
CardLinkComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: HttpClient },
    { type: ChangeDetectorRef }
];
CardLinkComponent.propDecorators = {
    cardLink: [{ type: Input }],
    _contextualMenu: [{ type: ViewChild, args: ['contextualMenu', { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-card-link',
                template: "<div *ngIf=\"id\" class=\"card-link\" [ngStyle]=\"{ 'background-color': backgroundColor }\" (click)=\"onClickCardLink()\">\n        <div class=\"card-link-custom\">\n            <div #contextualMenu class=\"card-link-custom__icon\" (click)=\"onClickContextualMenu($event)\">\n                <ucc-icon *ngIf=\"canShowContextualMenu()\" key=\"moreVerticalIcon\"></ucc-icon>\n            </div>\n        </div>\n        <div>\n            <ucc-icon *ngIf=\"icon && !cardLink.image\" class=\"card-link__icon\" [key]=\"icon\" [iconColor]=\"iconColor\"></ucc-icon>\n            <div *ngIf=\"cardLink.image\" class=\"card-link__image\" [style.background-image]=\"backgroundImage\"></div>\n        </div>\n        <div class=\"card-link__title\">\n            {{ cardLinkTitle }}\n        </div>\n</div>\n",
                styles: ["::ng-deep .card-link{width:250px;height:125px;font-size:14px;border:1px solid #dadada;background-color:#fff;display:grid;grid-template-rows:0fr 3fr 3fr}::ng-deep .card-link:hover{cursor:pointer;background-color:#eff9ff!important}::ng-deep .card-link-custom{display:grid;justify-items:end}::ng-deep .card-link-custom__icon{position:absolute;margin:5px;padding:4px;color:#666;border:0px;border-radius:50%;cursor:pointer}::ng-deep .card-link-custom__icon .baseIcon{font-size:15px;width:auto;height:auto}::ng-deep .card-link-custom__icon:hover{background-color:#eee}::ng-deep .card-link-custom__icon:active{background-color:#666;color:#fff}::ng-deep .card-link__icon .baseIcon{font-size:30px;display:grid;justify-content:center;align-content:end;height:100%;width:100%}::ng-deep .card-link__image{height:100%;background-position:bottom;background-size:30px;background-color:transparent;background-repeat:no-repeat}::ng-deep .card-link__title{color:#666;display:flex;justify-content:center;align-items:start;text-align:center;margin:5px;line-height:1.15}\n"]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }, { type: ɵngcc6.HttpClient }, { type: ɵngcc0.ChangeDetectorRef }]; }, { cardLink: [{
            type: Input
        }], _contextualMenu: [{
            type: ViewChild,
            args: ['contextualMenu', { read: ElementRef }]
        }] }); })();

class CardLinkModule {
}
CardLinkModule.ɵfac = function CardLinkModule_Factory(t) { return new (t || CardLinkModule)(); };
CardLinkModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardLinkModule });
CardLinkModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CardLinkComponent
                ],
                exports: [
                    CardLinkComponent
                ],
                imports: [
                    CommonModule,
                    IconModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardLinkModule, { declarations: function () { return [CardLinkComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [CardLinkComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de una página de [Card Link Components]{@link CardLinkComponent}.
 *
 * @example
 *      <ucc-card-link-container
 *        [cardLinks]="cardLinks">
 *      </ucc-card-link-container>
 */
class CardLinkContainerComponent {
    constructor() {
        this.cardLinks = null;
    }
    /** @ignore */
    trackById(index, cardLink) {
        return cardLink.id;
    }
}
CardLinkContainerComponent.ɵfac = function CardLinkContainerComponent_Factory(t) { return new (t || CardLinkContainerComponent)(); };
CardLinkContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardLinkContainerComponent, selectors: [["ucc-card-link-container"]], inputs: { cardLinks: "cardLinks" }, decls: 2, vars: 2, consts: [[1, "card-link-container"], ["class", "card-link-container__item", 3, "cardLink", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "card-link-container__item", 3, "cardLink"]], template: function CardLinkContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CardLinkContainerComponent_ucc_card_link_1_Template, 1, 1, "ucc-card-link", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.cardLinks)("ngForTrackBy", ctx.trackById);
    } }, directives: [ɵngcc1.NgForOf, CardLinkComponent], styles: ["[_nghost-%COMP%] {display:block;height:100%;background:#f5f5f5;position:relative;overflow-y:auto}[_nghost-%COMP%]  .card-link-container{display:flex;flex-flow:wrap;padding:20px}[_nghost-%COMP%]  .card-link-container__item{margin-right:15px;margin-bottom:15px}"] });
CardLinkContainerComponent.propDecorators = {
    cardLinks: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkContainerComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-card-link-container',
                template: "<div class=\"card-link-container\">\n    <ucc-card-link *ngFor=\"let cardLink of cardLinks; trackBy: trackById\" class=\"card-link-container__item\" [cardLink]=\"cardLink\"></ucc-card-link>\n</div>\n",
                styles: [":host::ng-deep{display:block;height:100%;background:#f5f5f5;position:relative;overflow-y:auto}:host::ng-deep .card-link-container{display:flex;flex-flow:wrap;padding:20px}:host::ng-deep .card-link-container__item{margin-right:15px;margin-bottom:15px}\n"]
            }]
    }], function () { return []; }, { cardLinks: [{
            type: Input
        }] }); })();

class CardLinkContainerModule {
}
CardLinkContainerModule.ɵfac = function CardLinkContainerModule_Factory(t) { return new (t || CardLinkContainerModule)(); };
CardLinkContainerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardLinkContainerModule });
CardLinkContainerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule,
            CardLinkModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkContainerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CardLinkContainerComponent
                ],
                exports: [
                    CardLinkContainerComponent
                ],
                imports: [
                    CommonModule,
                    IconModule,
                    CardLinkModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardLinkContainerModule, { declarations: function () { return [CardLinkContainerComponent]; }, imports: function () { return [CommonModule,
        IconModule, CardLinkModule]; }, exports: function () { return [CardLinkContainerComponent]; } }); })();

class UccLayoutsModule {
}
UccLayoutsModule.ɵfac = function UccLayoutsModule_Factory(t) { return new (t || UccLayoutsModule)(); };
UccLayoutsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UccLayoutsModule });
UccLayoutsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ServiceCodeModule,
            CarouselModule,
            AccordionModule,
            DragAndDropModule,
            CardLinkModule,
            CardLinkContainerModule
        ], ServiceCodeModule, CarouselModule, AccordionModule, DragAndDropModule, CardLinkModule, CardLinkContainerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UccLayoutsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ServiceCodeModule,
                    CarouselModule,
                    AccordionModule,
                    DragAndDropModule,
                    CardLinkModule,
                    CardLinkContainerModule
                ],
                exports: [
                    ServiceCodeModule,
                    CarouselModule,
                    AccordionModule,
                    DragAndDropModule,
                    CardLinkModule,
                    CardLinkContainerModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UccLayoutsModule, { imports: function () { return [CommonModule, ServiceCodeModule, CarouselModule, AccordionModule, DragAndDropModule, CardLinkModule, CardLinkContainerModule]; }, exports: function () { return [ServiceCodeModule, CarouselModule, AccordionModule, DragAndDropModule, CardLinkModule, CardLinkContainerModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionItemComponent, AccordionModule, CardLinkComponent, CardLinkContainerComponent, CardLinkContainerModule, CardLinkModule, CardsModule, CarouselComponent, CarouselItemComponent, CarouselModule, CarouselSlideAnimationType, DragAndDropModule, DragDropComponent, HelpLinksComponent, ServiceCodeButtonCardComponent, ServiceCodeCardComponent, ServiceCodeLayoutComponent, ServiceCodeModule, ServiceCodeNumberCardComponent, ServiceCodePipe, UccLayoutsModule };

